import React from "react";
import { Text } from "components";
import GameCard from "./GameCard";
import NewGameTile from "./NewGameTile";

/**
 * Responsive game grid (PRD §8). The New-game tile is always first; an empty
 * filter shows an inline message in place of cards but keeps the tile (§8.3).
 */
const GameGrid = ({ games, buildActions, notify, emptyMessage, showNewTile = true }) => (
  <div className="da-grid">
    {showNewTile && <NewGameTile />}
    {games.length === 0 ? (
      <div className="da-grid-empty">
        <Text variant="body" tone="muted">
          {emptyMessage}
        </Text>
      </div>
    ) : (
      games.map((game) => (
        <GameCard
          key={game.id}
          game={game}
          actions={buildActions(game)}
          notify={notify}
        />
      ))
    )}
  </div>
);

export default GameGrid;
